import ProfileApis from '@/services/apis/profile'

const UAParser = require('ua-parser-js')

const profile = new ProfileApis()
export default {

  data() {
    return {
      activeSessions: [],
      loading: false,
      onDeleteAllLoading: false,
      onDeleteLoading: false,
    }
  },
  mounted() {
    this.getSessions()
  },
  methods: {
    getSessions() {
      this.loading = true
      profile.activeSessions().then(async res => {
        this.activeSessions = res.data.results.map(ac => ({ ...ac, agent: this.getUserAgentDetails(ac.user_agent) }))
      }).finally(() => {
        this.loading = false
      })
    },
    getUserAgentDetails(uaString) {
      const parser = new UAParser(uaString)
      return {
        browser: parser.getBrowser(),
        device: parser.getDevice(),
        os: parser.getOS(),
        engine: parser.getEngine(),
        cpu: parser.getCPU(),
      }
    },
    async onDelete(session) {
      this.onDeleteLoading = true
      await this.onDeleteAll(session.id)
      this.onDeleteLoading = false
    },
    async onDeleteAll(sessionId) {
      this.onDeleteAllLoading = true
      await profile.deleteActiveSessions({ session_id: sessionId }).then(() => {
        this.getSessions()
      }).catch(err => {
        console.log(err)
      })
        .finally(() => {
          this.onDeleteAllLoading = false
        })
    },
  },
}
